import React, { useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import TextInput from '../../components/TextInput';
import Button from '../../components/Button';
import CreateUser from '../../components/CreateUser';
import api from '../../services/api';
import Snackbar from '../../util/SnackBar';

const mapUser = data => ({
  name: data.name || '',
  email: data.email || '',
  admin: data.admin || false,
  accountId: data.account?._id || data.accountId || '',
});

export default function EditUserByEmail() {
  const [searchEmail, setSearchEmail] = useState('');
  const [user, setUser] = useState(null);
  const [searching, setSearching] = useState(false);

  const handleSearch = async () => {
    const email = searchEmail.trim();
    if (!email) {
      Snackbar.warning('Please enter an email');
      return;
    }
    setSearching(true);
    try {
      const { data } = await api.get(`/newCostumers/${email}`);
      if (!data || !data.email) {
        Snackbar.error('User not found');
        return;
      }
      setUser(mapUser(data));
    } catch (err) {
      Snackbar.error('Failed to fetch user');
    } finally {
      setSearching(false);
    }
  };

  const handleSearchSubmit = e => {
    e.preventDefault();
    handleSearch();
  };

  const resetSearch = () => {
    setUser(null);
    setSearchEmail('');
  };

  const refetchUser = async () => {
    if (!user?.email) return;
    try {
      const { data } = await api.get(`/newCostumers/${user.email}`);
      if (data && data.email) setUser(mapUser(data));
    } catch (err) {
      // user already saw the success snackbar; refetch is best-effort
    }
  };

  if (user) {
    return (
      <CreateUser
        editedUser={user}
        handleBack={resetSearch}
        initLoading={refetchUser}
      />
    );
  }

  return (
    <Grid
      container
      style={{ alignContent: 'flex-start', padding: '20px 5px 10px' }}
    >
      <Grid container justifyContent="center">
        <Typography
          style={{
            fontFamily: 'Montserrat',
            fontSize: 24,
            lineHeight: '28px',
            letterSpacing: '0.1em',
            marginBottom: 25,
          }}
        >
          EDIT USER INFO
        </Typography>
      </Grid>

      <Grid container justifyContent="center" style={{ marginTop: 20 }}>
        <form onSubmit={handleSearchSubmit} style={{ width: 420 }}>
          <TextInput
            field="Email"
            value={searchEmail}
            onChange={e => setSearchEmail(e.target.value)}
            height={43}
            width={420}
            placeholder="Enter user email and press Enter"
          />
          <Grid container style={{ marginTop: 20 }}>
            <Button
              text="Search"
              color="#000"
              textColor="#fff"
              width={420}
              height={40}
              type="submit"
              loading={searching}
              onClick={handleSearch}
            />
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
}
